export default "__VITE_ASSET__0NIKOfoy__"